$.fn.chTokenModal = function (chTokenField, type) {
    var elm = this;
    var input = $(chTokenField);
    var val = input.val();

    elm.chCheckboxModal(type, val ? val.split(';') : [])

    input.on('tokenfield:createdtoken tokenfield:removedtoken', function (e) {
        var tokens = input.tokenfield('getTokens');

        // HACK tokenfield getTokens returns input when loading
        if (Array.isArray(tokens)) {
            elm.chCheckboxModal('vals', _.map(tokens, 'value'));
        }
    });

    elm.on({
        'click': function () {
            $('.token-input', input.parent()).focus();
        },
        'checkboxModal:change': function (e, arg) {
            // Don't trigger change for each new token added
            input.tokenfield('setTokens', arg.tokens, false);

            // Trigger after, also handles empty tokens which doesn't trigger change event...
            input.trigger($.Event('change', { initiator: 'tokenfield' }));
        }
    });
};
